import React from 'react';
import { ColumnConfig, Invoice } from '../../config';

interface InvoiceColumnProps {
  config: ColumnConfig;
  row: Invoice;
}

const InvoiceColumn: React.FC<InvoiceColumnProps> = ({ config, row }) => {
  const value = row[config.accessor as keyof Invoice];

  // Handle null/undefined values
  if (value === null || value === undefined) {
    return <span className="text-muted">-</span>;
  }

  // Handle different data types
  switch (config.accessor) {
    case 'job_number':
      return (
        <span className="job-number">
          {value}
        </span>
      );

    case 'client_name':
      return (
        <span className="client-name" title={value as string}>
          {value as string}
        </span>
      );

    case 'project_description':
      return (
        <span className="project-description" title={value as string}>
          {value as string}
        </span>
      );

    case 'invoice_number':
      return (
        <span className="invoice-number">
          {value}
        </span>
      );

    case 'notes':
      const noteText = value as string;
      return (
        <span className="notes" title={noteText}>
          {noteText ? noteText.substring(0, 50) + (noteText.length > 50 ? '...' : '') : '-'}
        </span>
      );

    default:
      return <span>{String(value)}</span>;
  }
};

export default InvoiceColumn;
